import { trackedArray, trackedObject } from "@ember/reactive/collections";
import Category from "discourse/models/category";

export function buildGroup(attrs) {
  return trackedObject({ ...attrs });
}

export function buildCategoryGroup(attrs) {
  return trackedObject({
    ...attrs,
    groups: trackedArray((attrs.groups || []).map(buildGroup)),
    categories: trackedArray(attrs.categories || []),
  });
}

export function groupName(groups, id) {
  const group = (groups || []).find((g) => g.id === id);
  return group?.full_name || group?.name;
}

export function findCategory(id) {
  return Category.findById(id);
}

export function categoryName(id) {
  return findCategory(id)?.displayName;
}

export function isPositiveInteger(value) {
  return !isNaN(value) && value >= 1;
}
